import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  subText?: string;
  className?: string;
  isCheckout?: boolean;
  fullWidthMobile?: boolean;
}
const CHECKOUT_URL = 'https://godeskcore.com/cart/42882980347952:1';
const buttonClasses = (fullWidthMobile: boolean) => `
  inline-block text-center cursor-pointer
  bg-gold-accent text-primary-dark font-sans font-bold uppercase
  tracking-[0.1em] px-[40px] py-[18px] rounded-[4px]
  transition-all duration-250 ease-in-out
  hover:-translate-y-[3px] hover:shadow-gold-glow
  no-underline
  ${fullWidthMobile ? 'w-full sm:w-auto' : ''}
`;
export function CTAButton({
  children,
  subText,
  className = '',
  isCheckout = false,
  fullWidthMobile = true
}: CTAButtonProps) {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className={`flex flex-col items-center ${fullWidthMobile ? 'w-full sm:w-auto' : ''} ${className}`} data-id="element-153">
      {isCheckout ? <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className={buttonClasses(fullWidthMobile)} data-id="element-154">
          {children}
        </a> : <button onClick={scrollToPricing} className={buttonClasses(fullWidthMobile)} data-id="element-155">
          {children}
        </button>}
      {subText && <p className="mt-3 text-[13px] font-sans text-cream-light/60 text-center max-w-[300px]" data-id="element-156">
          {subText}
        </p>}
    </div>;
}